<template>
  <div class="bg-app-gioco h-screen">
    <div class="container mx-auto">
      <div class="counter"><Counter /></div>
      <div class="suggestion">
        <Hint />
      </div>
      <div class="flex justify-center pt-1 sm:pt-2 md:pt-4 lg:pt-8 xl:pt-2">
        <div class="w-auto p-3">
          <div
            class="rounded-full h-24 w-24 flex flex-col items-center justify-center p-2 text-xl font-bold text-black bg-yellow shadow-2xl"
          >
            <div class="text-3xl">DEALER</div>
          </div>
        </div>
      </div>
      <div
        class="relative w-full pt-2 sm:pt-2 md:pt-4 lg:pt-0 xl:pt-0 pb-0 mx-auto"
      >
        <div class="w-full">
          <Dealer class="mb-1 sm:mb-1 md:mb-2 lg:mb-2 xl:pt-2" />
        </div>
      </div>

      <div
        class="relative w-full pt-2 sm:pt-2 md:pt-4 lg:pt-0 xl:pt-0 pb-0 mx-auto"
      >
        <div class="w-full">
          <transition name="slide-fase" mode="in-out">
            <Player class="mb-1 sm:mb-2 md:mb-4 lg:mb-1 xl:pt-1" />
          </transition>
        </div>
      </div>
      <div class="relative w-full">
        <Choices class="mx-auto" />
      </div>
      <div class="grid grid-cols-1 mt-2">
        <div
          class="m-auto text-center w-auto inline-block mt-2 pb-2 border-b-2 border-white border-dashed"
        >
          <a href="https://www.casino2k.com/" target="_blank">
            <img
              src="../assets/images/logo.png"
              style="width: 100px; height: auto"
            />
          </a>
        </div>
        <div class="m-auto text-center w-auto inline-block pt-4">
          <a
            href="https://www.casino2k.com/giochi/blackjack/strategie/contare-le-carte"
            target="_blank"
            class="btn bg-red-700 hover:bg-red-600 text-white font-bold py-2 px-4 rounded uppercase mt-2"
          >
            Approfondisci
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "../store";
import Dealer from "./Dealer";
import Player from "./Player";
import Choices from "./Choices";
import Counter from "./Counter";
import BlackjackChart from "./BlackjackChart";
import Hint from "./Hint";
export default {
  name: "GameTable",
  store,
  components: {
    Dealer,
    Player,
    Choices,
    Counter,
    BlackjackChart,
    Hint
  },
  computed: {
    gameCards() {
      return this.$store.getters.gameCards;
    },
    created() {}
  }
};
</script>



// WEBPACK FOOTER //
// src/components/GameTable.vue